var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.component.type,{tag:"component",attrs:{"v":_vm.validation},model:{value:(_vm.component.value),callback:function ($$v) {_vm.$set(_vm.component, "value", $$v)},expression:"component.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }